import { useNavigate } from "react-router";
import { X } from "lucide-react";
import { useActiveTrip } from "@/hooks/useActiveTrip";
import { cn } from "@/lib/utils";

export function ActiveTripBanner() {
  const { activeTrip, clearActiveTrip } = useActiveTrip();
  const navigate = useNavigate();

  if (!activeTrip) return null;

  return (
    <div
      className={cn(
        "fixed left-0 right-0 z-10 h-[var(--active-trip-banner-height)]",
        "flex items-center justify-between gap-3",
        "bg-primary text-primary-foreground px-4",
        "pl-[calc(1rem+env(safe-area-inset-left,0px))] pr-[calc(1rem+env(safe-area-inset-right,0px))]",
      )}
      style={{
        bottom:
          "calc(var(--tab-navigation-height) + env(safe-area-inset-bottom, 0px))",
      }}
    >
      <button
        className="flex-1 flex items-center gap-2 text-left min-w-0"
        onClick={() => {
          const params = new URLSearchParams({
            userStopId: activeTrip.userStopId ?? "",
            routeShortName: activeTrip.routeShortName ?? "",
            headsign: activeTrip.headsign ?? "",
          });
          void navigate(
            `/track/trip/${activeTrip.tripId}?${params.toString()}`,
          );
        }}
      >
        <span className="text-sm font-bold shrink-0">
          {activeTrip.routeShortName}
        </span>
        <span className="text-sm truncate">{activeTrip.headsign}</span>
        <span className="text-xs text-primary-foreground/80 shrink-0 ml-auto">
          Tap to resume →
        </span>
      </button>

      <button
        aria-label="Dismiss active trip"
        onClick={clearActiveTrip}
        className="shrink-0 p-1 rounded hover:bg-black/10 transition-colors"
      >
        <X size={16} />
      </button>
    </div>
  );
}
